// extracted by mini-css-extract-plugin
export default {"Play__button":"MediaSlide_Play__button__Nl3Fv","View__container":"MediaSlide_View__container__CVVqi","IonIcon_Placeholder":"MediaSlide_IonIcon_Placeholder__ZsZUV"};